package com.gastoncantera.intercom.push

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Punto único donde cada plataforma publica el token FCM actual (y sus refrescos).
 *
 * - Android: `IntercomMessagingService.onNewToken` y el fetch inicial.
 * - iOS: el `MessagingDelegate` (Swift) llama `PushTokenRegistry.shared.update(token)`.
 * - Web: tras `getToken(...)`.
 *
 * La UI (modo usuario) lo observa para persistirlo en `PresenceRepository`.
 */
object PushTokenRegistry {
    private val _token = MutableStateFlow<String?>(null)
    val token: StateFlow<String?> = _token.asStateFlow()

    fun update(token: String?) {
        _token.value = token
    }
}
